<template>

  <panel-navigation>
    <h1 class="text-lg font-semibold mb-4">Usage & Cost Dashboard</h1>

    <hr class="border-b border-gray-100 mb-3">

    <div class="flex flex-row flex-wrap">
        <div class="w-full pr-6 mb-4">
            <div class="dashboard-box">
                <v-card
                    class="pa-2"
                    tile
                >
                    <div class="p-3">

                        <div class="filters">
                            <input type="date" v-model="range.start" @change="fetchData" style="border: solid 1px #dddddd; padding: 3px; border-radius: 5px;" />
                            <input type="date" v-model="range.end" @change="fetchData" style="border: solid 1px #dddddd; margin-left: 10px; padding: 3px; border-radius: 5px;" />

                            <div class="quick-filters mt-2">
                                <button :class="{ active: activeFilter === 'current' }" @click="setCurrentMonth">Current Month</button>
                                <button :class="{ active: activeFilter === 'last7' }" @click="setLast7">Last 7 days</button>
                                <button :class="{ active: activeFilter === 'last30' }" @click="setLast30">Last 30 days</button>
                                <button :class="{ active: activeFilter === 'lastMonth' }" @click="setLastMonth">Last Month</button>
                            </div>
                        </div>

                        <div v-if="loaded">
                            <div v-if="twilio.usage_records.length">
                            <h3>Twilio Usage (Cost by Category)</h3>
                            <apexchart
                                type="bar"
                                :options="twilioChartOptions"
                                :series="twilioChartSeries"
                                height="350"
                            />
                            </div>

                            <!-- <div v-if="openai.daily_costs.length" style="margin-top: 40px;">
                            <h3>OpenAI Daily Costs</h3>
                            <apexchart
                                type="line"
                                :options="openaiChartOptions"
                                :series="openaiChartSeries"
                                height="300"
                            />
                            </div> -->

                            <div v-if="ultravoxCost !== null" style="margin-top: 40px;">
                                <strong class="mb-2">Twilio Cost</strong>
                                <div>Total Cost: ${{ twilioCost.toFixed(2) }}</div>
                            </div>

                            <div v-if="ultravoxCost !== null" style="margin-top: 40px;">
                                <strong>Ultravox Cost</strong>
                                <!-- <div>Total Minutes: {{ ultravoxMinutes.toFixed(2) }} min</div> -->
                                <div>Total Cost: ${{ ultravoxCost.toFixed(2) }}</div>
                            </div>

                            <div class="summary-cards" style="margin-top: 50px;">
                            <div class="card">
                                <strong class="mb-2">Stripe Payments Received</strong>
                                <div class="mb-1">Total received: <strong>${{ totalReceived.toFixed(2) }}</strong></div class="mb-1">
                                <ul>
                                <li v-for="payment in payments" :key="payment.id">
                                    {{ payment.created }} — ${{ payment.amount.toFixed(2) }}
                                </li>
                                </ul>
                            </div>

                            <div class="card">
                                <h3>Total API Costs</h3>
                                <p>Twilio + Ultravox: ${{ totalCosts.toFixed(2) }}</p>
                            </div>

                            <div class="card" :class="profit >= 0 ? 'profit' : 'loss'">
                                <h3>Profit / Loss</h3>
                                <p :style="{ color: profit >= 0 ? 'green' : 'red' }">
                                {{ profit >= 0 ? '+' : '-' }} ${{ Math.abs(profit).toFixed(2) }}
                                </p>
                            </div>
                            </div>
                        </div>

                        <v-skeleton-loader v-if="!loaded" type="article, article, article"></v-skeleton-loader>
                    </div>
                </v-card>
            </div>
        </div>
    </div>
</panel-navigation>
</template>

<script>
import axios from 'axios';
import ApexCharts from 'apexcharts';
import VueApexCharts from 'vue-apexcharts';
import PanelNavigation from '@/components/PanelNavigation.vue'

export default {
  components: {
    apexchart: VueApexCharts,
    PanelNavigation
  },
  data() {
    return {
      range: { start: '', end: '' },
      twilio: {},
      openai: {},
      ultravoxCost: null,
      twilioCost: null,
      payments: [],
      totalReceived: 0,
      totalCosts: 0,
      profit: 0,
      activeFilter: 'current',

      twilioChartOptions: {
        chart: { id: 'twilio-chart' },
        xaxis: { categories: [], labels: { show: false } },
        yaxis: { title: { text: 'Cost ($)' } },
        tooltip: { y: { formatter: val => `$${val.toFixed(2)}` } },
        dataLabels: { enabled: false },
        legend: { position: 'top' },
        colors: ['#008FFB', '#00E396', '#FEB019'],
      },
      twilioChartSeries: [],

      openaiChartOptions: {
        chart: { id: 'openai-chart' },
        xaxis: { categories: [] },
        yaxis: { title: { text: 'Cost ($)' } },
        tooltip: { y: { formatter: val => `$${val.toFixed(2)}` } },
        stroke: { curve: 'smooth' },
        dataLabels: { enabled: false },
        colors: ['#775DD0'],
      },
      openaiChartSeries: [],

      loaded: false
    };
  },
  computed: {
    ultravoxMinutes() {
      return this.ultravoxCost ? this.ultravoxCost / 0.05 : 0;
    },
  },
  methods: {
    fetchData() {
        let self = this;
        self.loaded = false;
      if (!this.range.start || !this.range.end) return;

      axios.get(process.env.VUE_APP_API_ENDPOINT + '/usage', { params: this.range, headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        })
        .then(res => {
          self.twilio = res.data.twilio || {};
        //   self.openai = res.data.openai || {};
          // self.ultravoxCost = res.data.ultravoxCost || 0;
          self.ultravoxCost = 125;
          self.twilioCost = res.data.twilioCost || 0;
          self.payments = res.data.payments || [];
          self.totalReceived = res.data.totalReceived || 0;
          self.totalCosts = (res.data.totalCosts || 0) + self.ultravoxCost;
          self.profit = (res.data.profit || 0) - self.ultravoxCost;

          self.prepareTwilioChart();
        //   self.prepareOpenAIChart();

          self.loaded = true;
        })
        .catch(err => {
          console.error('Error fetching usage data:', err);
        });
    },

    prepareTwilioChart() {
      const usageRecords = this.twilio.usage_records || [];
      if (usageRecords.length === 0) {
        this.twilioChartSeries = [];
        this.twilioChartOptions.xaxis.categories = [];
        return;
      }

      // Group by category, sum price
      const grouped = usageRecords.reduce((acc, rec) => {
        const cat = rec.category || 'Other';
        acc[cat] = (acc[cat] || 0) + parseFloat(rec.price);
        return acc;
      }, {});

      this.twilioChartOptions.xaxis.categories = Object.keys(grouped);
      this.twilioChartSeries = [
        {
          name: 'Cost',
          data: Object.values(grouped),
        },
      ];
    },

    prepareOpenAIChart() {
      const dailyCosts = this.openai.daily_costs || [];
      if (dailyCosts.length === 0) {
        this.openaiChartSeries = [];
        this.openaiChartOptions.xaxis.categories = [];
        return;
      }

      // Sort by date ascending
      dailyCosts.sort((a, b) => new Date(a.date) - new Date(b.date));

      this.openaiChartOptions.xaxis.categories = dailyCosts.map(dc => dc.date);
      this.openaiChartSeries = [
        {
          name: 'Daily Cost',
          data: dailyCosts.map(dc => parseFloat(dc.amount)),
        },
      ];
    },

    setCurrentMonth() {
      const today = new Date();
      this.range.start = new Date(today.getFullYear(), today.getMonth(), 1)
        .toISOString()
        .substr(0, 10);
      this.range.end = new Date(today.getFullYear(), today.getMonth() + 1, 0)
        .toISOString()
        .substr(0, 10);
      this.activeFilter = 'current';
      this.fetchData();
    },

    setLast7() {
      const today = new Date();
      const lastWeek = new Date(today);
      lastWeek.setDate(today.getDate() - 7);
      this.range.start = lastWeek.toISOString().substr(0, 10);
      this.range.end = today.toISOString().substr(0, 10);
      this.activeFilter = 'last7';
      this.fetchData();
    },

    setLast30() {
      const today = new Date();
      const last30 = new Date(today);
      last30.setDate(today.getDate() - 30);
      this.range.start = last30.toISOString().substr(0, 10);
      this.range.end = today.toISOString().substr(0, 10);
      this.activeFilter = 'last30';
      this.fetchData();
    },

    setLastMonth() {
      const today = new Date();
      const firstDayLast = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const lastDayLast = new Date(today.getFullYear(), today.getMonth(), 0);
      this.range.start = firstDayLast.toISOString().substr(0, 10);
      this.range.end = lastDayLast.toISOString().substr(0, 10);
      this.activeFilter = 'lastMonth';
      this.fetchData();
    },
  },
  created() {
    this.setCurrentMonth();
  },
};
</script>

<style scoped>
.filters {
  margin-bottom: 20px;
}

.quick-filters button {
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 6px 12px;
  border: 1px solid #ccc;
  background: white;
  cursor: pointer;
  border-radius: 4px;
  font-weight: 500;
}

.quick-filters button.active {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

.summary-cards {
  display: flex;
  gap: 20px;
  margin-top: 30px;
  flex-wrap: wrap;
}

.card {
  border: 1px solid #ddd;
  padding: 15px;
  width: 300px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);
}

.profit p {
  color: green;
  font-weight: bold;
}

.loss p {
  color: red;
  font-weight: bold;
}

.card ul {
  max-height: 120px;
  overflow-y: auto;
  padding-left: 15px;
  margin-top: 10px;
}
</style>